/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { COLOR } from '@ordermentum/ui-constants';
import { SVGIcons } from './icons';
import { getSize } from './utilities';
import { IconWrapper, LegacyIcon } from './index.styles';

type Props = {
  name: string;
  color?: string;
  modifiers?: { [key: string]: string | any } | string;
  size?: string;
  inActive?: boolean;
  shadow?: boolean;
  onClick?: any;
  viewBox?: string;
};

const base = {
  fontSize: '1.3rem',
  '&.orange span::before': {
    color: COLOR.PRIMARY,
  },
};

const defaultColor = COLOR.GRAY_400;

const iconColors = {
  orange: COLOR.PRIMARY,
  star: COLOR.YELLOW_500,
  'star-outline': COLOR.GRAY_400,
  exo: COLOR.BLUE,
  payment: COLOR.BLUE,
  info: COLOR.BLUE_500,
  red: COLOR.RED,
  warning: COLOR.YELLOW_500,
  cancel: COLOR.RED,
  plus: COLOR.BLUE,
  'right-open-big': COLOR.PRIMARY,
  default: defaultColor,
};

const colors = (name: string, inActive: boolean, color?: string) => {
  const activeColor = color || iconColors[name] || defaultColor;
  return {
    [`& .om-icon-${name}::before`]: {
      color: inActive ? COLOR.DISABLED : activeColor,
    },
  };
};

/**
 * @deprecated New designs should use the icons provided in
 * @ordermentum/ui-shared/foundations/Icons
 */
export const Icon = ({
  name,
  modifiers = {},
  color,
  inActive = false,
  size = '24px',
  shadow = false,
  viewBox = '0 0 24 24',
}: Props) => {
  const svgKey = Object.keys(SVGIcons).find(x => x === name);
  if (svgKey) {
    return (
      <IconWrapper size={size} color={color} data-id="icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={getSize(size)}
          height={getSize(size)}
          viewBox={viewBox}
          className={shadow ? 'shadow' : ''}
        >
          {SVGIcons[svgKey]}
        </svg>
      </IconWrapper>
    );
  }

  return (
    <span
      css={css(base, colors(name, inActive, color), modifiers)}
      data-id="icon"
      data-react-clickout="exclude"
    >
      <LegacyIcon
        size={size}
        className={`om-icon-${name}`}
        data-react-clickout="exclude"
      />
    </span>
  );
};

export default Icon;
